import { useState } from 'react';
import { useMutation } from 'react-query';
import api from '../../utils/api';
import { UserContextType, useUser } from '../../utils/context/User';
import Utils from '../Utils';

import style from './SessionLoadingModal.module.css';
import { Loader } from '@mantine/core';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function SessionLoadingModal(props: Props) {
  return (
    <Utils.Modal title="Accès à vos abonnements" isOpen={props.isOpen} onClose={props.onClose}>
      <div className={style.content}>
        <div className={style.text}>Chargement de votre session sécurisée en cours...</div>
        <Loader size="xl" />
      </div>
    </Utils.Modal>
  );
}
